<script>
import ViewClaimDocuments from "@/components/commons/claims/ViewDocuments.vue";
export default {
  name: "ClaimDetailsModal",

  data() {
    return {
      viewDocuments: false,
      claimDocuments: [],
    };
  },

  props: {
    claim: Object,
    investigation: Object,
    showModal: Boolean,
  },

  methods: {
    fetchClaimDocuments() {
      this.$root.loading = true;
      let url = `FIles/GetClaimsDocumentswithClaimNo`;
      url += `?ClaimNo=${this.claim.claimNo}`;
      this.claimDocuments = [];
      return this.$http
        .get(url)
        .then(({ data }) => {
          this.claimDocuments = data;
          this.$root.loading = false;
          this.viewDocuments = true;
        })
        .catch(() => {
          this.$root.loading = false;
        });
    },
  },

  components: {

    "view-claim-documents": ViewClaimDocuments,
  },
};
</script>
<template>
  <tail-modal :show="showModal" dimension="md:w-1/2 w-10/12">
    <template v-slot:title>
      <div class="w-full flex flex-wrap">
        <div class="flex-1">
          <h5 class="font-medium text-sm">Claim Details</h5>
        </div>
        <div class="flex-1 text-right">
          <button v-if="claim.claimNo"
            @click.prevent="fetchClaimDocuments"
            class="btn-sm btn-primary text-xs rounded"
          >
            <i class="fa fa-file"></i> Claim Documents
          </button>
        </div>
        <view-claim-documents
          :showModal="viewDocuments"
          :claim="claim"
          :documents="claimDocuments"
          @closeModal="viewDocuments = false"
        />
      </div>
    </template>
    <template v-slot:modal-body>
      <div class="w-full flex flex-wrap items-center my-1 bg-gray-200">
        <div class="md:w-1/2 w-full p-3">
          <h5 class="font-medium text-sm capitalize">
            Test: {{ investigation.test || investigation.service }}
          </h5>
        </div>
        <div class="md:w-1/2 w-full p-3">
          <h5 class="font-medium text-sm capitalize">
            Patient: {{ investigation.patient || investigation.names }}
          </h5>
        </div>
        <div class="md:w-1/2 w-full p-3">
          <h5 class="font-medium text-sm capitalize">
            MRN: {{ investigation.patientId || investigation.patientID }}
          </h5>
        </div>
        <div class="md:w-1/2 w-full p-3">
          <h5 class="font-medium text-sm capitalize">
            OP File No: {{ investigation.opfileno }}
          </h5>
        </div>
        <div class="md:w-1/2 w-full p-3">
          <h5 class="font-medium text-sm capitalize">
            IP File No: {{ investigation.ipfileno }}
          </h5>
        </div>
        <div class="md:w-1/2 w-full p-3">
          <h5 class="font-medium text-sm capitalize">
            Status: {{ investigation.patientstatus }}
          </h5>
        </div>
      </div>
      <div class="w-full flex flex-wrap my-2">
        <div class="md:w-1/3 w-full p-2">
          <h5 class="font-medium text-sm">Bill Item: {{ claim.item }}</h5>
        </div>
        <div class="md:w-1/3 w-full p-2">
          <h5 class="font-medium text-sm">
            Insurance: {{ claim.organization }}
          </h5>
        </div>
        <div class="md:w-1/3 w-full p-2">
          <h5 class="font-medium text-sm">Invoice No: {{ claim.invoiceNo }}</h5>
        </div>
        <div class="md:w-1/3 w-full p-2">
          <h5 class="font-medium text-sm">Claim No: {{ claim.claimNo }}</h5>
        </div>
        <div class="md:w-1/3 w-full p-2">
          <h5 class="font-medium text-sm">
            Org Claim No: {{ claim.organizationClaimNo || `-` }}
          </h5>
        </div>
        <div class="md:w-1/3 w-full p-2">
          <h5 class="font-medium text-sm">
            Preauth No: {{ claim.preAuthNo || `-` }}
          </h5>
        </div>
        <div class="md:w-1/3 w-full p-2">
          <h5 class="font-medium text-sm">
            Mcc: {{ claim.organizationClaimNo }}
          </h5>
        </div>
        <div class="md:w-1/3 w-full p-2">
          <h5 class="font-medium text-sm">Raised By: {{ claim.postedBy }}</h5>
        </div>
        <div class="w-full p-2">
          <h5 class="font-medium text-sm my-1">Comment:</h5>
          <p class="mt-1 text-xs break-words">{{ claim.description || `-` }}</p>
        </div>
      </div>
    </template>
    <template v-slot:modal-footer>
      <button
        class="btn-danger btn-sm text-xs rounded"
        @click.prevent="$emit(`closeModal`)"
      >
        <i class="fa fa-times"></i> Close
      </button>
    </template>
  </tail-modal>
</template>
